import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchBar from '../SearchBar/SearchBar';
import LoginPanel from './LoginPanel';
import Cart from './Cart/Cart';
import Navigation from './Navigation/Navigation';
import ErrorBoundaries from './../ErrorBoundaries/ErrorBoundary';
import Logo from './Logo';
import * as commonCallsActionCreators from '../../../actionCreators/common';
import * as registerActions from '../../../actionCreators/auth';
import * as cartActions from '../../../actionCreators/cart';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
import * as dittoCallsActionCreators from '../../../actionCreators/ditto';
import './MainNav.scss';
import AuthModal from 'desktop/components/AuthModal/AuthModalLoadable';
import getSetCookie from '../../../cookie';
import { getQueryParam, /* debounce, */ hideRepeatUserElem } from '../../../utils/helper';
import { Link } from 'react-router-dom';
import AuthModalNewLoadable from '../AuthModalNew/AuthModalNewLoadable';
// import LottieHeartIcon from '../../../CommonComponents/Lotties/LottieHeartIcon';
class MainNav extends Component {
  static propTypes = {
    mainNavigationData: PropTypes.any,
    loginStatus: PropTypes.bool,
    loginLoader: PropTypes.bool,
    showCart: PropTypes.bool,
    userInfo: PropTypes.any,
    login: PropTypes.bool,
    shortListData: PropTypes.object,
    cartData: PropTypes.object,
    toggleCart: PropTypes.func,
    isCartCount: PropTypes.any,
    isWishlistCount: PropTypes.number,
    redisCommonData: PropTypes.any,
  };

  constructor(props) {
    super(props);
    // this.handleScroll = debounce(this.handleScroll.bind(this), 300);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      showGoldAdded: true,
      showMenu: true,
      userSelectedMenuVisibility: false,
      scrolledToTop: true,
      showLoginPopUp: false,
      openTab: 'signin',
    };
    this.isRepeatUser = null;
    this.newCartFlowEnable = false;
    this.checkRepeatUser = this.checkRepeatUser.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    const type = location.search.indexOf('type=login') > -1;
    const now = new Date();
    const time = now.getTime();
    const expireTime = time + 60 * 60 * 1000;
    const expireTimeLocalStorage = localStorage.getItem('sessionShowPopupLogin');
    if (!expireTimeLocalStorage) {
      // localStorage.setItem('sessionShowPopupLogin', expireTime)
    }
    this.newCartFlowEnable = !!(
      this.props.redisCommonData &&
      this.props?.redisCommonData?.NEW_CART_FLOW_DESKTOP &&
      JSON.parse(this.props.redisCommonData?.NEW_CART_FLOW_DESKTOP)?.enable === 'ON'
    );
    setTimeout(() => {
      if (type) {
        this.setState({
          showLoginPopUp: Boolean(type),
        });
      }
    }, 100);
    // setTimeout(() => {
    //   if (!this.props.login && (Number(expireTimeLocalStorage) < time)) {
    //     this.setState({
    //       showLoginPopUp: true,
    //       openTab: 'signup',
    //     });
    //   }
    //   // localStorage.setItem('sessionShowPopupLogin', expireTime)
    // }, 5000);
  }

  componentDidUpdate(prevProps) {
    const {
      isCartCount,
      cartActions,
      userInfo,
      dittoCallsAction,
      askUserLogin,
      loginStatus,
      commonCallsAction,
      location,
      localeInfo,
      redisCommonData,
    } = this.props;
    const { domain } = localeInfo;
    const exchangeFlow = sessionStorageHelper.getItem('exchangeFlow');
    const returnProductDetails = sessionStorageHelper.getItem('returnProduct') || {};
    const { returnAction } = returnProductDetails;
    // Desktop exchange flow
    if (prevProps.isCartCount !== isCartCount && isCartCount > 0) {
      if (exchangeFlow) {
        if (returnAction === 'exchange') {
          cartActions.getCart(null, false, false, false, true);
        }
      } else {
        cartActions.getCart();
      }
    }
    // End
    if (
      // getSetCookie.getCookie('isDittoID') === '' &&
      userInfo &&
      userInfo.result.dittos &&
      userInfo.result.dittos.length &&
      Boolean(parseInt(getSetCookie.getCookie('isLogined'), 10))
    ) {
      const dittoId = redisCommonData?.ENABLE_CYGNUS
        ? userInfo?.result?.cygnus?.cygnusId
        : userInfo.result.dittos[0];
      if (dittoId) {
        getSetCookie.setCookie('isDittoID', dittoId);
        localStorage.setItem(
          'ditto-platform',
          userInfo.result.ditto && userInfo.result.ditto.platform
        );
      }
    }
    if (
      prevProps.userInfo !== userInfo &&
      getSetCookie.getCookie('guest_dittoid') !== '' &&
      getSetCookie.getCookie('isLogined') === '1'
    ) {
      dittoCallsAction.saveUpdateDitto(getSetCookie.getCookie('isDittoID'));
      dittoCallsAction.addNewDitto(getSetCookie.getCookie('isDittoID'));
      commonCallsAction.dittoAuth(getSetCookie.getCookie('isDittoID'));
      localStorage.setItem('ditto-platform', 'desktop');
      document.cookie = `guest_dittoid=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${
        localeInfo.cookieDomain || '.lenskart.com'
      };path=/`;
    }
    if (!loginStatus && prevProps.askUserLogin !== askUserLogin && askUserLogin) {
      this.openLoginPopup();
    }
    if (
      loginStatus &&
      window.location.pathname.indexOf('/customer/') !== -1 &&
      prevProps.askUserLogin !== askUserLogin &&
      !askUserLogin
    ) {
      this.closeLoginPopup();
    }

    // This condition is case when user comes from retrypayment page.
    if (
      location.state &&
      location.state.redirectUrl &&
      prevProps.loginStatus !== loginStatus &&
      loginStatus
    ) {
      window.location.href = `${domain}/customer/account/#/`;
    }
    if (location.pathname === '/' && prevProps.loginStatus !== loginStatus) {
      this.checkRepeatUser();
    }
    window.onpopstate = () => {
      if (location.pathname === '/') {
        sessionStorage.setItem('backTrigger', 'true');
      }
    };
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  openLoginPopup = () => {
    this.setState({
      showLoginPopUp: true,
      openTab: 'signin',
    });
  };
  closeLoginPopup = () => {
    clearInterval(window.secondsTimer);
    this.setState({
      showLoginPopUp: false,
    });
  };

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
  }

  handleScroll() {
    const { catImgLink } = this.props;
    const scrollTop =
      window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop;
    const maxScroll = document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    // console.log(scrollTop + clientHeight, maxScroll - 367);
    const footer = document.getElementById('footer-container');
    const footerHeight = footer?.clientHeight || 370;
    const filtersContainer = document.getElementById('plp-filters-container');
    const filterTopOffset = filtersContainer?.style?.top || 94;
    const { section } = this.props;
    const offsetHeight = catImgLink ? 180 : 30;
    if (filtersContainer?.style) {
      if (scrollTop <= offsetHeight) {
        document.body.classList.remove('scrolltop');
        filtersContainer.style.height = '100vh';
        this.setState({ showMenu: true, scrolledToTop: true });
        // document.body.classList.remove('scrollbottom');
      } else {
        if (!this.props.isYotpoWidgets) {
          this.props.commonCallsAction.setYotpoWidgetsState({ isYotpoWidgets: true });
        }
        if (!this.state.userSelectedMenuVisibility) {
          this.setState({ showMenu: false, scrolledToTop: false });
          if (section === 'cat') {
            if (
              scrollTop + clientHeight >= maxScroll - footerHeight &&
              footer &&
              this.isInViewport(footer)
            ) {
              // document.body.classList.remove('scrolltop');
              // document.body.classList.add('scrollbottom');
              filtersContainer.style.height = `calc(100vh - ${
                scrollTop + clientHeight - maxScroll + footerHeight + filterTopOffset
              }px)`;
            } else {
              // document.body.classList.remove('scrollbottom');
              filtersContainer.style.height = '100vh';
              document.body.classList.add('scrolltop');
            }
          }
        } else {
          this.setState({ scrolledToTop: false });
          if (section === 'cat') {
            if (
              scrollTop + clientHeight >= maxScroll - footerHeight &&
              footer &&
              this.isInViewport(footer)
            ) {
              // document.body.classList.remove('scrolltop');
              // document.body.classList.add('scrollbottom');
              filtersContainer.style.height = `calc(100vh - ${
                scrollTop + clientHeight - maxScroll + footerHeight + filterTopOffset
              }px)`;
            } else {
              // document.body.classList.remove('scrollbottom');
              filtersContainer.style.height = '100vh';
              document.body.classList.add('scrolltop');
            }
          }
        }
      }
    } else if (scrollTop <= offsetHeight) {
      document.body.classList.remove('scrolltop');
      // document.body.classList.remove('scrollbottom');
    }
    // if (scrollTop + clientHeight > (maxScroll - 367) && footer && this.isInViewport(footer)) {
    //     document.body.classList.add('scrollbottom');
    // } else if (document.querySelector('.scrollbottom')) {
    //     document.body.classList.remove('scrollbottom');
    // }
  }

  cartOmniture(data) {
    const { userInfo, login } = this.props;
    const cxid = userInfo === null ? '' : userInfo.result.id;
    let productId = '';
    let cartLenskartPrice = '';
    let quanTityValue = '';
    let productTypeValue = '';
    let productBrandValue = '';
    let productFrameSizeValue = '';
    let productNameValue = '';
    let productOptionValue = '';
    let productPackageNameValue = '';
    let productCoatingValue = '';
    let frameTypeValue = '';
    const cartProductId = [];
    const lenskartPrice = [];
    const quanTity = [];
    const productType = [];
    const productBrand = [];
    const productFrameSize = [];
    const productName = [];
    const productOption = [];
    const productCoating = [];
    const productPackageName = [];
    const subCategory = [];
    let subCategoryStr = '';
    const addOn = [];
    let optionsPrice = {};
    const frametype = [];

    data.forEach(cartItem => {
      subCategory.push(cartItem.subcategory);
      subCategoryStr = subCategory.toString().replace(/,/g, '|').toLowerCase();
      cartProductId.push(cartItem.productId);
      productId = cartProductId.toString().replace(/,/g, '|').toLowerCase();
      quanTity.push(cartItem.quantity);
      quanTityValue = quanTity.toString().replace(/,/g, '|').toLowerCase();
      productType.push(cartItem.productTypeValue);
      productTypeValue = productType.toString().replace(/,/g, '|').toLowerCase();
      productFrameSize.push(cartItem.frameSize);
      productFrameSizeValue = productFrameSize.toString().replace(/,/g, '|').toLowerCase();
      productBrand.push(cartItem.brandName);
      productBrandValue = productBrand.toString().replace(/,/g, '|').toLowerCase();
      productName.push(cartItem.name);
      productNameValue = productName.toString().replace(/,/g, '|').toLowerCase();
      frametype.push(cartItem.frameType);
      frameTypeValue = frametype.toString().replace(/,/g, '|').toLowerCase();
      if (cartItem.catalogPrices.length > 2) {
        lenskartPrice.push(cartItem.catalogPrices[2].value);
        cartLenskartPrice = lenskartPrice.toString().replace(/,/g, '|').toLowerCase();
      } else {
        cartItem.catalogPrices.forEach(prices => {
          if (prices.name === 'Lenskart Price') {
            lenskartPrice.push(prices.value);
            cartLenskartPrice = lenskartPrice.toString().replace(/,/g, '|').toLowerCase();
          }
        });
      }
      if (cartItem.options.length >= 1) {
        productOption.push(cartItem.options[0].type);
        productOptionValue = productOption.toString().replace(/,/g, '|').toLowerCase();
        productPackageName.push(cartItem.options[0].name);
        productPackageNameValue = productPackageName.toString().replace(/,/g, '|').toLowerCase();
        if (cartItem.options.length > 1 && cartItem.options[1].type === 'COATING') {
          productCoating.push('Yes');
          productCoatingValue = productCoating.toString().replace(/,/g, '|').toLowerCase();
        } else {
          productCoating.push('No');
          productCoatingValue = productCoating.toString().replace(/,/g, '|').toLowerCase();
        }
      }
      cartItem.options.forEach(productOptionsType => {
        productOptionsType.catalogPrices.forEach(catalogOptions => {
          optionsPrice = catalogOptions.value;
        });
        addOn.push({
          addonid: productOptionsType.oid,
          addontype: productOptionsType.type,
          addonprice: optionsPrice,
          addonbaseproduct: cartItem.productId,
        });
      });
    });
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.slideCart.click.cartSummary(
        cxid,
        productId,
        cartLenskartPrice,
        quanTityValue,
        productBrandValue,
        productTypeValue,
        productOptionValue,
        productPackageNameValue,
        productCoatingValue,
        addOn,
        login,
        frameTypeValue,
        subCategoryStr,
        productFrameSizeValue,
        productNameValue
      );
    }
    sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
  }

  hideCart = () => {
    this.props.commonCallsAction.toggleCart(false);
  };

  hideGoldAdded = () => {
    this.setState({ showGoldAdded: false });
  };

  showWishList = () => {
    const { shortListData, wishlistTrue, section, loginStatus, commonCallsAction } = this.props;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.header.click.headerClick(section, 'shortlist', loginStatus);
    const productId = [];
    if (shortListData.result.numberOfProducts > 0) {
      if (shortListData.result.productList) {
        shortListData.result.productList.forEach(data => {
          productId.push(data.id);
        });
      }
    }
    if (wishlistTrue === false) {
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.load.headerShortlist(productId.toString());
      commonCallsAction.showWishlist(true);
    } else {
      commonCallsAction.showWishlist(false);
    }
  };

  showMenu = () => {
    this.setState({ showMenu: true, userSelectedMenuVisibility: true });
  };

  hideMenu = () => {
    this.setState({ showMenu: false, userSelectedMenuVisibility: false });
  };
  cartClickHandler = () => {
    const { section, loginStatus, commonCallsAction } = this.props;
    window.dtm.actiontype = 'view';
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.header.click.headerClick(section, 'CART', loginStatus);

    commonCallsAction.toggleCart(true);
    if (this.newCartFlowEnable) {
      this.props.history.push('/cart');
    }
  };
  checkRepeatUser() {
    const { userInfo } = this.props;
    if (userInfo && userInfo?.result?.hasPlacedOrder) {
      this.isRepeatUser = true;
      sessionStorage.setItem('isRepeatUser', 'true');
    } else {
      this.isRepeatUser = false;
      sessionStorage.removeItem('isRepeatUser');
    }
    const hideElem = document.getElementsByClassName('hide-repeat');
    if (hideElem) {
      hideRepeatUserElem(this.isRepeatUser, hideElem);
    }
  }

  render() {
    const {
      section,
      shortListData,
      loginStatus,
      cartData,
      location,
      appLogo,
      askUserLogin,
      login,
      registerActions,
      dataLocale,
      localeInfo,
      redisCommonData,
    } = this.props;

    const newLoginPopUp = !!(
      redisCommonData &&
      redisCommonData?.NEW_AUTH_POPUP_DESKTOP &&
      JSON.parse(redisCommonData?.NEW_AUTH_POPUP_DESKTOP).enable === 'ON'
    );
    const phoneConfig = redisCommonData?.PHONE_NUMBER_CONFIG
      ? JSON.parse(redisCommonData?.PHONE_NUMBER_CONFIG)
      : {};
    const { GOLD_ADDED_POPUP_HTML, TRACK_ORDER, WISHLIST, CART, ICON } = dataLocale || {};
    const locationQuery = location.search;
    const loyaltyAddedHtml = GOLD_ADDED_POPUP_HTML || '';
    let isLoyaltyProductAdded = false;
    if (cartData && cartData.result) {
      cartData.result.items.forEach(data => {
        if (!isLoyaltyProductAdded && data.classification === 'loyalty_services') {
          isLoyaltyProductAdded = true;
        }
      });
    }
    const navData = this.props.mainNavigationData && this.props.mainNavigationData.header;
    const rightNavData = this.props.mainNavigationData && this.props.mainNavigationData.rightBarNav;
    return (
      <div className="header-inner row mainNav">
        <div className="mainNav_container">
          {this.state.showLoginPopUp && (
            <>
              {!newLoginPopUp ? (
                <AuthModal
                  allowSignUp
                  askUserLogin={askUserLogin}
                  hideLogin={() => {
                    clearInterval(window.secondsTimer);
                    this.setState({
                      showLoginPopUp: false,
                    });
                  }}
                  openTab={this.state.openTab}
                />
              ) : (
                <AuthModalNewLoadable
                  allowSignUp
                  handleModalClose={this.closeLoginPopup}
                  hideLogin={() => {
                    clearInterval(window.secondsTimer);
                    this.setState({
                      showLoginPopUp: false,
                    });
                  }}
                  login={login}
                  openTab={this.state.openTab}
                />
              )}
            </>
          )}

          {!this.newCartFlowEnable && this.props.showCart && (
            <ErrorBoundaries>
              <Cart
                cartOmniture={data => {
                  this.cartOmniture(data);
                }}
                hideHandler={this.hideCart}
              />
            </ErrorBoundaries>
          )}
          <div
            className={`mainNav_top is-${!this.state.showMenu ? 'scroll' : 'no-scroll'}`}
            id="topNavigationBar"
          >
            <div
              className={`middle is-${
                !this.state.showMenu ? 'scroll' : 'no-scroll'
              } big-screen-wrapper`}
            >
              <div className="lenskart-brand display-flex align-items-center justify-content-between pos-rel">
                <Logo
                  appLogo={
                    location.pathname === ''
                      ? 'https://static.lenskart.com/media/desktop/img/site-images/main_logo.svg'
                      : appLogo
                  }
                  dataLocale={dataLocale}
                  pathPrefix={localeInfo.pathPrefix}
                />
                {!this.state.scrolledToTop &&
                  this.state.showMenu &&
                  this.state.userSelectedMenuVisibility && (
                    <i
                      aria-hidden="true"
                      className="fa fa-times mainNav_closeMenu"
                      onClick={() => this.hideMenu()}
                    ></i>
                  )}
                <img
                  alt="ph-no"
                  className="pos-abs ph-img"
                  src={phoneConfig?.imgUrl}
                  style={{ visibility: phoneConfig?.enable ? 'visible' : 'hidden' }}
                />
              </div>
              <SearchBar {...this.props} />
              <div className="fb-30 layout justify-content-end margin-l20">
                <div className="mainNav_details">
                  <div className="order-status">
                    <Link
                      title={TRACK_ORDER}
                      to={{ pathname: '/customer/account/' }}
                      onClick={() => {
                        window.dtm.LenskartRewamp.header.click.headerClick(
                          section,
                          'track-order',
                          loginStatus
                        );
                      }}
                    >
                      <div className="mainNav_name">
                        <span>{TRACK_ORDER}</span>
                      </div>
                    </Link>
                  </div>
                  <LoginPanel
                    {...this.props}
                    loginStatus={login}
                    openLoginTab={() => {
                      this.setState({
                        showLoginPopUp: true,
                        openTab: 'signin',
                      });
                      registerActions.resetMobileLoginProps();
                    }}
                    openSignUpTab={() => {
                      this.setState({
                        showLoginPopUp: true,
                        openTab: 'signup',
                      });
                    }}
                    redisCommonData={redisCommonData}
                  />
                  <div className="wishlist" id="shortList">
                    {/* <LottieHeartIcon /> */}
                    <a className="pos-rel" onClick={this.showWishList}>
                      <img
                        alt={ICON}
                        className="IconImage pos-abs"
                        src="https://static.lenskart.com/media/desktop/img/wishlist.png"
                      />
                      {shortListData.result.numberOfProducts > 0 && (
                        <span className="mainNav_nav-count-text shortlist-text pos-abs">
                          {shortListData.result.numberOfProducts}
                        </span>
                      )}
                      <span className="mainNav_nav-count">{WISHLIST}</span>
                    </a>
                  </div>
                  <div className="cart">
                    <a className="pos-rel" onClick={this.cartClickHandler}>
                      <img
                        alt={ICON}
                        className="IconImage pos-abs leftpx"
                        src="https://static.lenskart.com/media/desktop/img/cart.png"
                      />
                      {cartData.result.itemsCount > 0 && (
                        <span className="mainNav_nav-count-text pos-abs">
                          {cartData.result.itemsCount}
                        </span>
                      )}
                      <span className="mainNav_nav-count">{CART}</span>
                    </a>
                  </div>
                </div>
              </div>
              {locationQuery &&
                locationQuery.indexOf('gold_add=1') !== -1 &&
                isLoyaltyProductAdded && (
                  <div
                    dangerouslySetInnerHTML={{ __html: loyaltyAddedHtml }}
                    className={`col-sm-12 gold-added-container text-center ${
                      this.state.showGoldAdded ? '' : ' closed'
                    }`}
                    onClick={this.hideGoldAdded}
                  ></div>
                )}
            </div>
            <Navigation
              isMenuHidden={!this.state.showMenu}
              location={location}
              navData={navData}
              rightNavData={rightNavData}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  toggleCart: state.common.toggleCart,
  exchangeFlowSet: state.myAccount.exchangeFlowSet,
  showCart: state.common.showCart,
  isCartCount: state.common.isCartCount,
  isWishlistCount: state.common.isWishlistCount,
  cartData: state.cart.cartData,
  productData: state.product.productData,
  categoryData: state.category.categoryData,
  catImgLink: state.category.catImgLink,
  login: state.common.login,
  appLogo: state.common.appLogo,
  userInfo: state.common.userInfo,
  askUserLogin: state.common.askUserLogin,
  isYotpoWidgets: state.common.isYotpoWidgets,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    cartActions: bindActionCreators(cartActions, dispatch),
    registerActions: bindActionCreators(registerActions, dispatch),
    dittoCallsAction: bindActionCreators(dittoCallsActionCreators, dispatch),
  };
}

MainNav.defaultProps = {
  redisCommonData: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNav);
